import { t } from "i18next"

type AgeFormat = {
  day: string
  week: string
  month: string
  year: string
}

type Age = {
  readonly years: number
  readonly months: number
  readonly weeks: number
  readonly days: number
}

const localizedFormat = () => ({
  day: t("common.date.dayShort"),
  week: t("common.date.weekShort"),
  month: t("common.date.monthShort"),
  year: t("common.date.yearShort"),
})

const defaultFormat: AgeFormat = localizedFormat()

function ageFormatter(age: Age, format: AgeFormat = defaultFormat): string {
  if (age.days <= 30) {
    return `${age.days} ${format.day}`
  }

  if (age.days > 30 && age.months <= 4) {
    return `${age.weeks} ${format.week}`
  }

  if (age.years <= 3) {
    return `${age.months} ${format.month}`
  }

  return `${age.years} ${format.year}`
}

const localizeAge = (age: Age, format?: AgeFormat): string => {
  return ageFormatter(age, format ? format : defaultFormat)
}

const ageFormat = ({ age, format }: { age: Age; format?: AgeFormat }) => {
  const displayAge = localizeAge(age, format ? format : defaultFormat)
  return displayAge
}

export { ageFormat, type Age }
